<script lang="ts">
  import UserCircleCheck from "~icons/ph/user-circle-check";
  import { onMount } from "svelte";
  import type { Name } from "../ConfirmContactInfoTask.svelte"

  let {
    name = $bindable(),
    back,
  }: {
    name: Name;
    back: () => void;
  } = $props();

  let firstNameInput = $state<HTMLInputElement>();
  let firstName = $state(name.firstName);
  let middleName = $state(name.middleName)
  let surname = $state(name.surname);
  let formerSurname = $state(name.formerSurname);

  function confirm(event): void {
    event.preventDefault();
    name = {
      firstName: firstName?.trim(),
      surname: surname?.trim(),
      middleName: middleName?.trim(),
      formerSurname: formerSurname?.trim()
    };
    back();
  }

  onMount(() => firstNameInput?.focus());
</script>

<form onsubmit={confirm}>
  <h2 class="ui-title">Update Legal Name</h2>

  <div class="ui-alert ui-alert-info mb-4">
    <UserCircleCheck />
    <p>For your security, we’ll ask for a <b>driving licence or passport</b> to verify changes.</p>
  </div>

  <fieldset class="ui-fieldset">
    <legend>First name</legend>
    <input
      id="first_name"
      type="text"
      class="ui-input"
      bind:this={firstNameInput}
      bind:value={firstName}
      required
    />
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend>Middle name</legend>
    <input
      id="middle_name"
      type="text"
      class="ui-input"
      bind:value={middleName}
    />
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend>Surname</legend>
    <input
      id="surname"
      type="text"
      class="ui-input"
      bind:value={surname}
      required
    />
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend>Former surname</legend>
    <input
      id="former_surname"
      type="text"
      class="ui-input"
      bind:value={formerSurname}
    />
  </fieldset>

  <div class="floating-footer">
    <button class="btn btn-ghost" type="button" onclick={back}>Back</button>
    <button class="btn btn-primary" type="submit">Continue</button>
  </div>
</form>